// ------------------------REGARDING FOR STATIC CONTENT  ------------------------------------------
import logoImage from '../assets/images/emity_logo.png'; 
const websiteName = "WellBeing360";  
const websiteTagline = "Care You Can Trust.";  
const websiteUrl = "https://www.WellBeing360.com";  
const logoUrl = logoImage;
const androidAppLink = "android-app://com.WellBeing360.sura_user";
const iosAppLink = "ios-app://com.WellBeing360.sura_user";    
const currentLocation = sessionStorage.getItem('country');  
const currencyIcon = currentLocation === 'India' ? '₹' : '$';


// ----------------------- REGARDING FOR SEO / META TAG   -----------------------------------------------
window.logoUrl = logoImage;
window.dynamicAndroidAppLink = "https://play.google.com/store/apps/details?id=com.example";
window.dynamicIosAppLink = "https://apps.apple.com/us/app/example/id123456789";
window.dynamicWebsiteName = websiteName;
window.websiteTagline = 'Care You Can Trust.';
window.websiteUrl = 'https://www.WellBeing360.com';
window.metaOgDescription = `Discover ${websiteName}, your trusted partner in health and wellness, offering comprehensive services to support your well-being and a healthier future...`;
window.metatwitterDescription = `Discover ${websiteName}, your trusted partner in health and wellness, supporting your journey to a healthier life...`;
const metaDescriptionEn = `Discover ${websiteName}, your trusted partner in health and wellness, offering personalized care and comprehensive services to enhance your well-being and health...`;
const metaDescriptionTh = `ค้นพบ ${websiteName} พันธมิตรที่คุณวางใจในสุขภาพและความเป็นอยู่ที่ดี, ให้บริการดูแลแบบเฉพาะเจาะจงและครอบคลุมเพื่อเสริมสร้างสุขภาพของคุณ...`;
const keywordsTemplate = {
    en: {
      static: "Health Services, Wellness, Medical Care, Personalized Health Solutions",
      dynamic: `${websiteName}`
    },
    th: {
      static: "บริการสุขภาพ, ความเป็นอยู่ที่ดี, การดูแลทางการแพทย์, โซลูชั่นสุขภาพเฉพาะบุคคล",
      dynamic: `${websiteName}`
    }
  };
  



export {
  websiteName,
  websiteTagline,
  websiteUrl,
  logoUrl,
  currencyIcon,
  metaDescriptionEn,
  metaDescriptionTh,
  keywordsTemplate,
  androidAppLink,
  iosAppLink,
};